<template>
  <span class="icon-box">
    <div v-if="O_show" class="icon-box">
      <Poptip v-model="visible_yellow" placement="right" width="420" transfer popper-class="monitorAuditPrompt">
        <Icon type="md-help-circle" class="icon-yellow f-s-20" />
        <template #title>
          <div><i style="font-weight: bold;">异常提示</i></div>
        </template>
        <template #content>
          <div v-for="(item, index) in O_list" :key="item.id">
            <Form
              :ref="'formValidate' + index"
              :model="item"
              label-position="top"
              label-colon
              hide-required-mark
            >
              <FormItem
                :label="item.problemDesc"
                :rules="{ validator: validateAuditStatus, trigger: 'change' }"
                prop="auditStatus"
              >
                <RadioGroup v-if="item.auditStatus === 'Y' || item.auditStatus==='N'" v-model="item.auditStatus">
                  <Radio label="Y" disabled>确认无误</Radio>
                  <Radio label="N" disabled>存疑</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem
              v-if="item.auditStatus === 'Y' || item.auditStatus==='N'"
                prop="auditOpinion"
                :rules="{
                  validator: validateAuditOpinion(item.auditStatus),
                  trigger: 'blur',
                }"
              >
                <Input
                  v-model="item.auditOpinion"
                  disabled
                  type="textarea"
                  maxlength="200"
                ></Input>
              </FormItem>
              <FormItem class="buttons"> </FormItem>
            </Form>
          </div>
          <div>
            <Button type="primary" @click="close">确认</Button>
          </div>
        </template>
      </Poptip>
    </div>

    <div v-if="Y_show" class="icon-box">
      <Poptip v-model="visible_green" placement="right" width="420" transfer popper-class="monitorAuditPrompt">
        <Icon type="md-alert" class="icon-green f-s-20" />
        <template #title>
          <div><i style="font-weight: bold;">异常提示</i></div>
        </template>
        <template #content>
          <div v-for="item in Y_list" :key="item.id">
            <Form
              ref="formValidate"
              :model="item"
              label-position="top"
              label-colon
              hide-required-mark
            >
              <FormItem :label="item.problemDesc" prop="auditStatus">
                <RadioGroup v-model="item.auditStatus" v-if="item.auditStatus === 'Y' || item.auditStatus==='N'">
                  <Radio label="Y" disabled>确认无误</Radio>
                  <Radio label="N" disabled>存疑</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="auditOpinion" v-if="item.auditStatus === 'Y' || item.auditStatus==='N'">
                <Input
                  disabled
                  v-model="item.auditOpinion"
                  type="textarea"
                ></Input>
              </FormItem>
              <FormItem class="buttons">
                <Button style="margin-right: 8px" @click="close">确认</Button>
              </FormItem>
            </Form>
          </div>
        </template>
      </Poptip>
    </div>

    <div v-if="N_show" class="icon-box">
      <Poptip v-model="visible_red" placement="right" width="420" transfer popper-class="monitorAuditPrompt">
        <Icon type="md-alert" class="icon-red f-s-20" />
        <template #title>
          <div><i style="font-weight: bold;">异常提示</i></div>
        </template>
        <template #content>
          <div v-for="item in N_list" :key="item.id">
            <Form
              ref="formValidate"
              :model="item"
              label-position="top"
              label-colon
              hide-required-mark
            >
              <FormItem :label="item.problemDesc" prop="auditStatus">
                <RadioGroup v-model="item.auditStatus" v-if="item.auditStatus === 'Y' || item.auditStatus==='N'">
                  <Radio label="Y" disabled>确认无误</Radio>
                  <Radio label="N" disabled>存疑</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="auditOpinion" v-if="item.auditStatus === 'Y' || item.auditStatus==='N'">
                <Input
                  disabled
                  v-model="item.auditOpinion"
                  type="textarea"
                ></Input>
              </FormItem>
              <FormItem class="buttons">
                <Button style="margin-right: 8px" @click="close">确认</Button>
              </FormItem>
            </Form>
          </div>
        </template>
      </Poptip>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    concreteData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: Number,
      default: null,
    },
    fieldName: {
      type: String,
      default: "",
    },
    from: {
      type: String,
      default: "",
    },
    infoItem: {
      type: String,
      default: "",
    },
    contrastData: {
      //需要比对是否相同的字段
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible_yellow: false,
      visible_green: false,
      visible_red: false,
    };
  },
  computed: {
    O_show() {
      return this.iconShow("O");
    },
    Y_show() {
      return this.iconShow("Y");
    },
    N_show() {
      return this.iconShow("N");
    },
    O_list() {
      return this.formList("O");
    },
    Y_list() {
      return this.formList("Y");
    },
    N_list() {
      return this.formList("N");
    },
  },
  methods: {
    validateAuditStatus(rule, value, callback) {
      if (!value || value === "O") {
        callback(new Error("必填"));
      } else {
        callback();
      }
    },
    validateAuditOpinion(auditStatus) {
      let rule = (rule, value, callback) => {
        if (auditStatus === "Y" && !value) {
          callback(new Error("必填"));
        } else {
          callback();
        }
      };
      return rule;
    },

    iconShow(type) {
      const index = this.concreteData[type]
        ? this.concreteData[type].findIndex((item) => {
            if (this.from === "onsite" || this.from === "base-info") {
              return item.fieldName === this.contrastData.fieldName;
            } else if(this.from === "monitor5" || this.from === "monitor3"){
              return item.fieldName === this.contrastData.fieldName &&
                     item.unitName === this.contrastData.unitName
            } else if (this.from === "report1" || this.from === "report2") {
              return (
                item.fieldName === this.contrastData.fieldName &&
                item.infoItem === this.contrastData.infoItem &&
                item.fuelName === this.contrastData.fuelName &&
                item.unitName === this.contrastData.unitName
              );
            } else if (this.from === "report4") {
              return (
                item.fieldName === this.contrastData.fieldName &&
                item.infoItem === this.contrastData.infoItem &&
                item.unitName === this.contrastData.unitName
              );
            } else if (this.from === "report9") {
              return (
                item.fieldName === this.contrastData.fieldName &&
                item.infoItem === this.contrastData.infoItem &&
                item.month === this.contrastData.month &&
                item.unitName === this.contrastData.unitName &&
                item.baseId === this.contrastData.id
              );
            }
          })
        : -1;
      return index !== -1;
    },

    formList(type) {
      let list = [];
      this.concreteData[type] &&
        this.concreteData[type].forEach((element) => {
          if (
            element.fieldName === this.contrastData.fieldName &&
            (this.from === "onsite" || this.from === "base-info")
          ){
            list.push(element);
          } else if (
            element.fieldName === this.contrastData.fieldName &&
            element.unitName === this.contrastData.unitName &&
            (this.from === "monitor5" || this.from === "monitor3"))
           {
            list.push(element);
          } else if (
            element.fieldName === this.contrastData.fieldName &&
            element.infoItem === this.contrastData.infoItem &&
            element.fuelName === this.contrastData.fuelName &&
            element.unitName === this.contrastData.unitName &&
            (this.from === "report1" || this.from === "report2")
          ) {
            list.push(element);
          } else if (
            element.fieldName === this.contrastData.fieldName &&
            element.infoItem === this.contrastData.infoItem &&
            element.unitName === this.contrastData.unitName &&
            this.from === "report4"
          ) {
            list.push(element);
          } else if (
            element.fieldName === this.contrastData.fieldName &&
            element.infoItem === this.contrastData.infoItem &&
            element.unitName === this.contrastData.unitName &&
            element.month === this.contrastData.month &&
            element.baseId === this.contrastData.id &&
            this.from === "report9"
          ) {
            list.push(element);
          }
        });
      return list;
    },

    submit(val) {
      let arr = [];
      let list = JSON.parse(JSON.stringify(val));
      list.forEach((item, index) => {
        let form = "formValidate" + index;
        this.$refs[form][0].validate((valid) => {
          if (valid) {
            arr.push(true);
          } else {
            arr.push(false);
          }
        });
      });
      let flag = arr.every((item) => {
        return item === true;
      });
      if (flag) {
        let params = {
          type: this.type,
          auditInfoList: [],
        };
        let obj = {};
        list.forEach((element) => {
          obj = {
            id: element.id,
            auditStatus: element.auditStatus,
            auditOpinion: element.auditOpinion,
          };
          params.auditInfoList.push(obj);
        });
        // console.log(params);
        this.$emit("commit", params);
      }
    },

    close() {
      this.visible_yellow = false;
      this.visible_green = false;
      this.visible_red = false;
    },
  },
};
</script>

<style lang="less">
.icon-box {
    display: inline;
    margin-left: 2px;
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
  }
  .icon-yellow {
    color: #d98200;
  }
  .icon-red {
    color: #d9111b;
  }
  .icon-green {
    color: #4b7901;
  }
  .f-s-20 {
    font-size: 20px;
  }
.monitorAuditPrompt {
    z-index : 99999  !important;
   .ivu-poptip-body {
    padding: 8px 16px !important;
  }
}
</style>